import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { createCompany } from '../api';

const CompanyModal = ({ open, onClose, onSuccess }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (open) form.resetFields();
    }, [open, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);
            const res = await createCompany({ name: values.name });
            message.success('Company created');
            onSuccess(res.data);
        } catch (err) {
            if (err.errorFields) return;
            message.error(err.response?.data?.message || 'Failed to create company');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title="Add Company"
            open={open}
            onCancel={onClose}
            onOk={handleSubmit}
            confirmLoading={submitting}
            destroyOnClose
            width={420}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Company Name"
                    rules={[{ required: true, message: 'Company name is required' }]}
                >
                    <Input placeholder="Enter company name" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CompanyModal;
